/**
 * Welcome discount: after valid phone + email + "Applica Sconto",
 * show −35% on catalog prices and apply Shopify code PRIMO35
 * to cart + checkout.
 */
(function () {
  const STORAGE_KEY = "cd_welcome_discount";
  const DEFAULT_PERCENT = 35;
  const DEFAULT_CODE = "PRIMO35";
  const MONEY_LOCALE = document.documentElement.lang || "it-IT";
  /** Products with this tag are excluded from PRIMO35 in Shopify too. */
  const EXCLUDED_TAG = "no-primo35";

  const state = {
    active: false,
    percent: DEFAULT_PERCENT,
    code: DEFAULT_CODE,
    email: "",
    phone: "",
    cartDiscountApplied: false,
    // null until the cart has been checked for excluded products
    cartHasExcluded: null,
  };

  const excludedByHandle = {};

  function productIsExcluded(handle) {
    if (!handle) return Promise.resolve(false);
    if (!(handle in excludedByHandle)) {
      excludedByHandle[handle] = fetch(routesRoot() + "products/" + encodeURIComponent(handle) + ".js", {
        credentials: "same-origin",
      })
        .then(function (r) {
          return r.ok ? r.json() : null;
        })
        .then(function (p) {
          return !!(p && (p.tags || []).indexOf(EXCLUDED_TAG) !== -1);
        })
        .catch(function () {
          return false;
        });
    }
    return excludedByHandle[handle];
  }

  function checkCartExcluded(cart) {
    const items = (cart && cart.items) || [];
    return Promise.all(
      items.map(function (item) {
        return productIsExcluded(item.handle);
      })
    ).then(function (flags) {
      state.cartHasExcluded = flags.some(Boolean);
      return state.cartHasExcluded;
    });
  }

  function routesRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  }

  function readStored() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function customerWasSaved() {
    try {
      return localStorage.getItem("cd_welcome_customer_saved") === "1";
    } catch (e) {
      return false;
    }
  }

  function markCustomerSaved() {
    try {
      localStorage.setItem("cd_welcome_customer_saved", "1");
    } catch (e) {}
  }

  function reopenIfSignupNotSaved() {
    try {
      if (customerWasSaved()) return;
      const stored = readStored();
      if (!stored || !stored.email) return;
      const popup = document.getElementById("welcome-discount-popup");
      if (!popup) return;
      localStorage.removeItem("popup-closed-" + (popup.dataset.id || "0"));
    } catch (e) {}
  }

  function persist() {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          percent: state.percent,
          code: state.code,
          email: state.email,
          phone: state.phone,
          at: Date.now(),
        })
      );
    } catch (e) {
      /* ignore quota */
    }
  }

  function formatMoney(cents) {
    const amount = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(MONEY_LOCALE, {
        style: "currency",
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || "EUR",
      }).format(amount);
    } catch (e) {
      return "€" + amount.toFixed(2).replace(".", ",");
    }
  }

  function parseMoneyToCents(text) {
    if (!text) return null;
    const cleaned = String(text)
      .replace(/[^\d,.\-]/g, "")
      .trim();
    if (!cleaned) return null;
    let normalized = cleaned;
    if (cleaned.includes(",") && cleaned.includes(".")) {
      normalized = cleaned.replace(/\./g, "").replace(",", ".");
    } else if (cleaned.includes(",")) {
      normalized = cleaned.replace(",", ".");
    }
    const value = parseFloat(normalized);
    if (Number.isNaN(value)) return null;
    return Math.round(value * 100);
  }

  function discountedCents(cents, percent) {
    return Math.round((Number(cents) * (100 - percent)) / 100);
  }

  function applyToPriceEl(priceEl) {
    if (!priceEl || priceEl.dataset.welcomeDiscountApplied === "true") return;
    if (priceEl.closest("[data-welcome-excluded]")) return;

    let baseCents = priceEl.dataset.welcomePrice
      ? parseInt(priceEl.dataset.welcomePrice, 10)
      : null;

    if (baseCents == null || Number.isNaN(baseCents)) {
      const regular =
        priceEl.querySelector(".price-item--regular") ||
        priceEl.querySelector(".price-item--sale");
      baseCents = parseMoneyToCents(regular && regular.textContent);
    }

    if (baseCents == null || Number.isNaN(baseCents) || baseCents <= 0) return;

    const saleCents = discountedCents(baseCents, state.percent);
    const maxCents = priceEl.dataset.welcomePriceMax
      ? parseInt(priceEl.dataset.welcomePriceMax, 10)
      : null;

    priceEl.classList.add("price--on-sale", "price--welcome-discount");
    priceEl.dataset.welcomeDiscountApplied = "true";

    const saleItem = priceEl.querySelector(".price-item--sale");
    const compareItem = priceEl.querySelector(".price__compare .price-item--regular");
    const regularItem = priceEl.querySelector(".price__regular .price-item--regular");

    let saleText = formatMoney(saleCents);
    let compareText = formatMoney(baseCents);

    if (maxCents && !Number.isNaN(maxCents) && maxCents > baseCents) {
      const saleMax = discountedCents(maxCents, state.percent);
      saleText = formatMoney(saleCents) + " - " + formatMoney(saleMax);
      compareText = formatMoney(baseCents) + " - " + formatMoney(maxCents);
    }

    if (saleItem) saleItem.textContent = saleText;
    if (compareItem) compareItem.textContent = compareText;
    if (regularItem && !saleItem) {
      regularItem.innerHTML =
        '<s class="price-item price-item--regular">' +
        compareText +
        "</s> " +
        '<span class="price-item price-item--sale">' +
        saleText +
        "</span>";
    }

    if (!priceEl.querySelector(".welcome-discount-badge")) {
      const badge = document.createElement("span");
      badge.className = "welcome-discount-badge";
      badge.textContent = "−" + state.percent + "%";
      priceEl.appendChild(badge);
    }
  }

  function applyToLoosePriceNodes(root) {
    root.querySelectorAll("[data-welcome-price]:not(.price)").forEach(applyToPriceEl);
    root.querySelectorAll(".product-sticky-bar__price, .price-wrapper").forEach(function (wrap) {
      const inner = wrap.querySelector(".price");
      if (inner) applyToPriceEl(inner);
    });
  }

  function applyCatalogPrices(root) {
    if (!state.active) return;
    const scope = root || document;
    scope.querySelectorAll(".price[data-welcome-price], .price").forEach(applyToPriceEl);
    applyToLoosePriceNodes(scope);
    document.documentElement.classList.add("welcome-discount-active");
  }

  /** Visual fallback on cart line / totals when Shopify code is not yet reflected */
  function applyCartVisualDiscount(root) {
    if (!state.active) return;
    // A flat −35% on totals would be wrong if the cart holds an excluded product
    if (state.cartHasExcluded !== false) return;
    const scope = root || document;
    const selectors = [
      ".cart-item__price",
      ".cart-item__final-price",
      ".totals__subtotal-value",
      ".cart__subtotal",
      ".cart-drawer__total",
      "[data-cart-subtotal]",
      ".totals__total-value",
      ".cart-item .price",
      "cart-drawer .price",
      "#CartDrawer .price",
      ".drawer__footer .price",
    ];

    selectors.forEach(function (sel) {
      scope.querySelectorAll(sel).forEach(function (el) {
        if (el.dataset.welcomeDiscountApplied === "true") return;
        if (el.querySelector(".price")) {
          applyToPriceEl(el.querySelector(".price"));
          return;
        }
        const cents = parseMoneyToCents(el.textContent);
        if (cents == null || cents <= 0) return;
        const sale = discountedCents(cents, state.percent);
        el.dataset.welcomeDiscountApplied = "true";
        el.classList.add("price--welcome-discount");
        el.innerHTML =
          "<s>" +
          formatMoney(cents) +
          "</s> <span class=\"price-item--sale\">" +
          formatMoney(sale) +
          '</span> <span class="welcome-discount-badge">−' +
          state.percent +
          "%</span>";
      });
    });
  }

  function patchCheckoutLinks(root) {
    if (!state.active || !state.code) return;
    const scope = root || document;
    const code = encodeURIComponent(state.code);
    scope.querySelectorAll('a[href*="/checkout"], form[action*="/checkout"]').forEach(function (el) {
      if (el.tagName === "A") {
        try {
          const url = new URL(el.href, window.location.origin);
          if (!url.searchParams.get("discount")) {
            url.searchParams.set("discount", state.code);
            el.href = url.toString();
          }
        } catch (e) {
          if (el.href.indexOf("discount=") === -1) {
            el.href += (el.href.indexOf("?") >= 0 ? "&" : "?") + "discount=" + code;
          }
        }
      } else if (el.tagName === "FORM") {
        let input = el.querySelector('input[name="discount"]');
        if (!input) {
          input = document.createElement("input");
          input.type = "hidden";
          input.name = "discount";
          el.appendChild(input);
        }
        input.value = state.code;
      }
    });

    // Checkout buttons that navigate via JS
    scope.querySelectorAll('button[name="checkout"], [name="checkout"]').forEach(function (btn) {
      if (btn.dataset.welcomeCheckoutPatched === "true") return;
      btn.dataset.welcomeCheckoutPatched = "true";
      btn.addEventListener(
        "click",
        function () {
          // Ensure cookie + cart discount before leaving
          activateDiscountCode(state.code);
        },
        true
      );
    });
  }

  function activateDiscountCode(code) {
    if (!code) return Promise.resolve(null);
    const root = routesRoot();

    // 1) Classic discount URL (sets discount_code cookie)
    const cookiePromise = fetch(root + "discount/" + encodeURIComponent(code), {
      credentials: "same-origin",
      redirect: "follow",
    }).catch(function () {});

    // 2) Ajax Cart API — applies code to cart for drawer/page totals
    const cartPromise = fetch(root + "cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ discount: code }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        return checkCartExcluded(cart).then(function () {
          return cart;
        });
      })
      .then(function (cart) {
        const codes = (cart && cart.discount_codes) || [];
        const ok = codes.some(function (c) {
          return c && c.code === code && c.applicable;
        });
        state.cartDiscountApplied = !!ok || (cart && cart.total_discount > 0);
        if (state.cartDiscountApplied) {
          document.dispatchEvent(
            new CustomEvent("welcome-discount:cart-updated", { detail: { cart: cart } })
          );
          // Ask theme cart to refresh UI if available
          document.dispatchEvent(new CustomEvent("cart:refresh"));
          if (window.theme && typeof window.theme.cartUpdate === "function") {
            try {
              window.theme.cartUpdate(cart);
            } catch (e) {}
          }
        }
        return cart;
      })
      .catch(function () {
        return null;
      });

    return Promise.all([cookiePromise, cartPromise]).then(function (results) {
      return results[1];
    });
  }

  function activate(options) {
    options = options || {};
    state.active = true;
    state.percent = Number(options.percent) || DEFAULT_PERCENT;
    state.code = options.code || DEFAULT_CODE;
    if (options.email) state.email = options.email;
    if (options.phone) state.phone = options.phone;
    persist();
    applyCatalogPrices(document);
    applyCartVisualDiscount(document);
    patchCheckoutLinks(document);
    activateDiscountCode(state.code).then(function (cart) {
      // If Shopify applied real discount, refresh cart UI; else keep visual fallback
      if (!state.cartDiscountApplied) {
        applyCartVisualDiscount(document);
      } else {
        // Real discount — still badge catalog prices
        applyCatalogPrices(document);
        patchCheckoutLinks(document);
      }
      return cart;
    });
    document.dispatchEvent(
      new CustomEvent("welcome-discount:applied", {
        detail: { percent: state.percent, code: state.code },
      })
    );
  }

  function phoneIsValid(value) {
    const digits = String(value || "").replace(/\D/g, "");
    return digits.length >= 8 && digits.length <= 15;
  }

  let successCloseTimer = null;

  function closeWelcomePopup() {
    const popup = document.getElementById("welcome-discount-popup");
    if (!popup) return;
    const closeBtn = popup.querySelector(".popup-close");
    if (closeBtn) closeBtn.click();
    else popup.classList.remove("popup-open");
  }

  function armSuccessClose() {
    if (successCloseTimer) return;
    const popup = document.getElementById("welcome-discount-popup");
    if (popup) popup.classList.add("popup-open");
    successCloseTimer = setTimeout(closeWelcomePopup, 3000);
  }

  function showSuccess(form) {
    const msg = form.querySelector(".welcome-discount-success");
    if (msg) msg.hidden = false;
    armSuccessClose();
  }

  function onSubmit(e) {
    const form = e.target.closest("form.newsletter-form--welcome-discount");
    if (!form) return;
    if (form.dataset.welcomeReady === "true") return;

    const emailInput = form.querySelector('input[type="email"]');
    const phoneInput = form.querySelector('input[type="tel"]');
    if (!emailInput || !phoneInput) return;

    phoneInput.setCustomValidity("");
    const phoneOk = phoneInput.value.trim() && phoneInput.checkValidity() && phoneIsValid(phoneInput.value);
    if (!phoneOk) {
      e.preventDefault();
      e.stopPropagation();
      if (phoneInput.value.trim() && !phoneIsValid(phoneInput.value)) {
        phoneInput.setCustomValidity("Inserisci un numero di telefono valido");
      }
      phoneInput.reportValidity();
      return;
    }

    if (!emailInput.checkValidity()) {
      e.preventDefault();
      e.stopPropagation();
      emailInput.reportValidity();
      return;
    }

    const note = form.querySelector("[data-welcome-note]");
    if (note) note.value = "Telefono: " + phoneInput.value.trim();

    const meta = form.querySelector("[data-welcome-discount]") || form;
    const percent = parseInt(meta.getAttribute("data-discount-percent"), 10) || DEFAULT_PERCENT;
    const code = meta.getAttribute("data-discount-code") || DEFAULT_CODE;

    activate({
      percent: percent,
      code: code,
      email: emailInput.value.trim(),
      phone: phoneInput.value.trim(),
    });

    showSuccess(form);
    form.dataset.welcomeReady = "true";
  }

  function bind() {
    document.addEventListener("input", function (e) {
      const input = e.target;
      if (
        input &&
        input.matches &&
        input.matches('form.newsletter-form--welcome-discount input[type="tel"]')
      ) {
        input.setCustomValidity("");
      }
    });

    document.addEventListener("submit", onSubmit, true);

    document.addEventListener("shopify:section:load", function () {
      applyCatalogPrices(document);
      applyCartVisualDiscount(document);
      patchCheckoutLinks(document);
    });

    document.addEventListener("variant:change", function () {
      document.querySelectorAll(".price[data-welcome-discount-applied]").forEach(function (el) {
        el.dataset.welcomeDiscountApplied = "false";
        el.classList.remove("price--welcome-discount");
      });
      applyCatalogPrices(document);
    });

    // Re-apply after add-to-cart / cart drawer opens
    document.addEventListener("cart:updated", function () {
      if (!state.active) return;
      activateDiscountCode(state.code).then(function () {
        applyCartVisualDiscount(document);
        patchCheckoutLinks(document);
      });
    });

    document.addEventListener("click", function (e) {
      const checkout = e.target.closest('a[href*="/checkout"], button[name="checkout"], [href$="/checkout"]');
      if (!checkout || !state.active) return;
      // Fire-and-forget ensure code is on cart before navigation
      activateDiscountCode(state.code);
    }, true);

    if ("MutationObserver" in window) {
      const observer = new MutationObserver(function (mutations) {
        if (!state.active) return;
        let needsCart = false;
        for (let i = 0; i < mutations.length; i++) {
          const nodes = mutations[i].addedNodes;
          for (let j = 0; j < nodes.length; j++) {
            const node = nodes[j];
            if (node.nodeType !== 1) continue;
            if (node.matches && node.matches(".price")) {
              applyToPriceEl(node);
            } else if (node.querySelectorAll) {
              node.querySelectorAll(".price").forEach(applyToPriceEl);
              if (
                node.matches("cart-drawer, .cart-drawer, #CartDrawer, form[action='/cart']") ||
                node.querySelector("cart-drawer, .cart-drawer, [data-cart-subtotal], .totals__subtotal-value")
              ) {
                needsCart = true;
              }
            }
          }
        }
        if (needsCart) {
          fetch(routesRoot() + "cart.js", { credentials: "same-origin" })
            .then(function (r) {
              return r.json();
            })
            .then(checkCartExcluded)
            .catch(function () {
              state.cartHasExcluded = null;
            })
            .then(function () {
              applyCartVisualDiscount(document);
              patchCheckoutLinks(document);
            });
        }
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  function initFromStorage() {
    if (document.querySelector("[data-welcome-discount-posted]")) {
      markCustomerSaved();
    }
    const stored = readStored();
    if (stored && stored.percent) {
      activate({
        percent: stored.percent,
        code: stored.code || DEFAULT_CODE,
        email: stored.email || "",
        phone: stored.phone || "",
      });
      return;
    }
    if (customerWasSaved()) {
      activate({ percent: DEFAULT_PERCENT, code: DEFAULT_CODE });
    }
  }

  function ageVerified(popup) {
    try {
      const raw = localStorage.getItem("popup-age-" + (popup.dataset.id || ""));
      if (!raw) return false;
      const parsed = JSON.parse(raw);
      if (parsed.expires && Date.now() > parsed.expires) return false;
      return !!parsed.value;
    } catch (e) {
      return false;
    }
  }

  function maybeSkipPopup() {
    if (document.querySelector("[data-welcome-discount-posted]")) {
      armSuccessClose();
      return;
    }
    if (!customerWasSaved() || !state.active) return;
    document.querySelectorAll(".popup-main, .popup").forEach(function (popup) {
      if (popup.id !== "welcome-discount-popup" && !popup.querySelector(".newsletter-form--welcome-discount")) {
        return;
      }
      const needsAge = popup.querySelector("[data-age-gate]") && !ageVerified(popup);
      if (needsAge) {
        popup.dataset.skipOffer = "true";
        return;
      }
      popup.setAttribute("data-limit-display", "0");
      popup.classList.remove("popup-open");
      popup.style.display = "none";
      const overlay = popup.nextElementSibling;
      if (overlay && overlay.classList.contains("popup-overlay")) {
        overlay.style.display = "none";
      }
    });
  }

  function boot() {
    bind();
    initFromStorage();
    maybeSkipPopup();
  }

  reopenIfSignupNotSaved();

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  window.ContiWelcomeDiscount = {
    activate: activate,
    applyCatalogPrices: applyCatalogPrices,
    applyCartVisualDiscount: applyCartVisualDiscount,
    activateDiscountCode: activateDiscountCode,
    isActive: function () {
      return state.active;
    },
    isCartDiscountApplied: function () {
      return state.cartDiscountApplied;
    },
  };
})();
